import { InsightsOptionDto, InsightsOptionModel } from '../Common/InsightsOption.dto';

export type InsightsCombinedAnswerDto = Readonly<{
  option: InsightsOptionDto;
  score: number;
  count: number;
}>;

export type InsightsCombinedAnswerModel = Readonly<{
  option: InsightsOptionModel;
  score: number;
  count: number;
}>;

export const mapInsightsCombinedAnswerDtoToModel = (
  dto: InsightsCombinedAnswerDto
): InsightsCombinedAnswerModel => ({
  option: dto.option,
  score: dto.score,
  count: dto.count,
});
